import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import MoreVertIcon from "../../resources/images/icons-more-vertical.svg";
import type { BaseTableRow, TableColumnDef, TableProps } from "../../types/components/table.types";
import { getHeaderName } from "../../types/components/table.types";
import { Table } from "./Table";

interface LocationTableRow extends BaseTableRow {
  locationId?: string;
}

interface LocationTableProps extends TableProps<LocationTableRow> {
  onLocationAction: (e: any, row: LocationTableRow) => void;
}

export class LocationTable extends Table<LocationTableRow> {
  static columns = {
    name: {
      field: "name",
      label: "tableColumns.name"
    },
    actions: {
      field: "actions",
      label: "tableColumns.actions"
    }
  };

  static defaultProps = {
    ...Table.defaultProps,
    columns: [{ type: LocationTable.columns.name }, { type: LocationTable.columns.actions }],
    noRowsMessage: "",
    rowHasAction: null
  };

  constructor(props: LocationTableProps) {
    super(props);
  }

  getRowId(e: LocationTableRow) {
    return this.tableId + "_" + e.locationId;
  }

  initColumns() {
    const { columns, sortable, onLocationAction } = this.props;

    this.columns = [];

    if (!columns) return;

    columns.forEach((c: any) => {
      if (this.hasColumn(c)) {
        if (c.type === LocationTable.columns.name)
          this.columns.push({
            field: "name",
            sortable: sortable,
            headerName: getHeaderName(c, this.props.translate),
            flex: 1,
            filterable: false,
            disableReorder: true
          });
      }

      if (c.type === LocationTable.columns.actions)
        this.columns.push({
          field: "actions",
          type: "actions",
          filterable: false,
          disableReorder: true,
          align: "right",
          getActions: (params) => [
            <GridActionsCellItem
              icon={<MoreVertIcon />}
              label='Actions'
              onClick={(e) => onLocationAction?.(e, params.row)}
              key={Math.random().toString(36).substring(7)}
            />
          ]
        });
    });
  }
}
